import PropTypes from 'prop-types';
import React, { PureComponent } from 'react';
import { FormattedMessage, useIntl } from 'react-intl';
import { reduxForm } from 'redux-form';
import { Button, Form, Header } from 'components/HeroSemantic';
import { FormField, PasswordValidationHelper } from 'components';
import passwordValidation from './passwordValidation';

export class ResetPasswordForm extends PureComponent {
  static propTypes = {
    onSubmit: PropTypes.func.isRequired,
    intl: PropTypes.object.isRequired,
  };

  state = {
    password: '',
  };

  render() {
    const { formatMessage } = this.props.intl;
    const { password } = this.state;
    return (
      <Form size="large" className="attached segment" onSubmit={this.props.onSubmit} style={{ padding: '20px' }}>
        <Header>
          <FormattedMessage id="page.resetPassword.form.title" />
        </Header>
        <PasswordValidationHelper password={password} />
        <div className="mb-5 mt-5 flex flex-col gap-4">
          <FormField
            required
            fluid
            id="password"
            type="password"
            label={formatMessage({ id: 'page.resetPassword.form.label.password' })}
            element={Form.Input}
            // redux-form passes a non-string (false) once the field is emptied; PasswordValidationHelper needs a string
            onChange={(event, value) => this.setState({ password: typeof value === 'string' ? value : '' })}
          />
          <FormField
            required
            fluid
            id="repeatPassword"
            type="password"
            label={formatMessage({ id: 'page.resetPassword.form.label.retypePassword' })}
            element={Form.Input}
          />
        </div>
        <Button type="submit" color="green" size="large" disabled={(!password || password.length < 8)}>
          <FormattedMessage id="general.submit" />
        </Button>
      </Form>
    );
  }
}

const ReduxFormResetPassword = reduxForm({ form: 'resetPassword', validate: passwordValidation })(ResetPasswordForm);

const ResetPasswordFormWithIntl = props => {
  const intl = useIntl();
  // eslint-disable-next-line react/jsx-props-no-spreading
  return <ReduxFormResetPassword {...props} intl={intl} />;
};

export default ResetPasswordFormWithIntl;
